import * as React from 'react'
import { useTranslation } from 'react-i18next';

export default function SubHeader({ text, anchor = '', date = null }) {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'he';  // Check if the current language is Hebrew (RTL)

  return (
    <div className='index-h2-blue-wrapper' id={anchor ? anchor : ''}>
      <h2 className='index-h2-blue' dir={isRtl ? 'rtl' : 'ltr'}>
        <bdi>{text}</bdi>
        {date ? ` ${date}` : null}
      </h2>
    </div>
  );
}
